import React from 'react';

const TitleImagePage = ({ title, imageUrl, onTitleChange, onImageUrlChange }) => {
    return (
        <div>
            <input
                type="text"
                placeholder="Título"
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
            />
            <input
                type="text"
                placeholder="URL de la Imagen"
                value={imageUrl}
                onChange={(e) => onImageUrlChange(e.target.value)}
            />
            {imageUrl && <img src={imageUrl} alt="Preview" />}
        </div>
    );
};

export default TitleImagePage;
